import React, { Component } from 'react';
import { connect } from "react-redux";
import { config, ROLES, DISPATCH_ID } from '../libs/utils/Const';
import $ from "jquery";
import { ApiClient } from "../libs/apiClient/ApiClient";
import moment from 'moment';
import ReactDOM from 'react-dom';
import './MenuNavbar.css';

class MenuNavbar extends Component {

    subCategorySearch = async (valor,seccion, subCategory = null) => {
        const {setIdCategory, setLocation,itemsReducer: {searchByCategories},setNextPage,setView} = this.props;
        await setIdCategory(valor);
        await setNextPage(0); 
        await setLocation('menuCategories');
        await setView('')
        searchByCategories(valor,0,seccion, subCategory);
    };

    // ############## REGION RENDER DE SUBCATEGORIAS (NIVEL 2) ##############
    // renderSubCategories = (categoryL1) => {
    //     let divSubCategories = document.getElementById('subMenuNivel2');
    //     let divSubFamilies = document.getElementById('subMenuNivel3');  // Prueba
    //     if(categoryL1 && categoryL1.categoriesL2.length > 0){            
    //         const listSubCategory = categoryL1.categoriesL2.map((subCategory) =>
    //             <div 
    //             // style={{border : '2px solid #312164', borderRadius : '14px' , margin : '3px'}} 
    //             >
    //                 <div 
    //                     className='nav-link' 
    //                     data-toggle="collapse"
    //                     data-target="#desplegable"
    //                     aria-expanded="false"
    //                     aria-controls="desplegable" 
    //                     style={{fontSize:"0.9rem", /*height:50,*/ fontWeight:'700', color:'rgb(238 149 67)', }}
    //                     onClick={() => this.subCategorySearch(subCategory.Code , "productos", categoryL1.Code)}
    //                     // onMouseOver = {() => this.renderSubFamilies(subCategory)}
    //                 >
    //                     <i class="fa fa-dot-circle-o" aria-hidden="true" style={{color : 'black'}}></i>
    //                     {' '+subCategory.U_name}
    //                 </div>
    //                 {/* ############## REGION DE SUBFAMILIAS (NIVEL 3) ############## */}
    //                 {subCategory.categoriesL3 && subCategory.categoriesL3.map((subFamily) =>
    //                     <div onClick={() => this.subCategorySearch( subFamily.Code , "productos2",subCategory.Code)}>
                            
    //                         <span 
    //                             className='nav-link' 
    //                             data-toggle="collapse"
    //                             data-target="#desplegable"
    //                             aria-expanded="false"
    //                             aria-controls="desplegable" 
    //                             style={{fontSize:"0.9rem", paddingBottom:0}}
    //                         >
    //                             <i class="fa fa-circle fa-lg" aria-hidden="true" style={{}}></i>
    //                             {' '+subFamily.U_name}
    //                         </span>
    //                     </div>
    //                 )}
    //                 {/* <div class="dropdown-divider"></div> */}
    //                 {/* // ############## FIN REGION ############## */}

    //             </div>
    //         );
    //         ReactDOM.render(
    //             <span>
    //                 <div className='designScroll row' style={{maxHeight: 305, width:'100%', justifyContent:'flex-start', alignItems : 'start'}}>
    //                     {listSubCategory}
    //                 </div>
    //             </span>
    //             , divSubCategories
    //         );
    //         divSubCategories.style.display = "block";
    //         // divSubFamilies.style.display = "none";
    //     }else{
    //         if(divSubCategories){
    //         divSubCategories.style.display = "none";
    //         // divSubFamilies.style.display = "none";
    //         }
    //     }
    // };
    // ############## FIN REGION ##############

    render() {
        const { configReducer: { history, idCategoryFilter }, sessionReducer: { user }, sessionReducer } = this.props;
        return (
            <div>
                <div data-toggle="collapse" href="#desplegable" aria-expanded="false" aria-controls="desplegable" 
                    style={ {width:'150vw' , height : '150vh', background : 'transparemt', zIndex : '-1',position : 'absolute', top : '-173px',/* border : '10px solid yellow'*/ } }>   
                </div>
                
                <div className='collapse' id='Categorys' style={{display:"flex", padding:0}}>
                    
                    {/* ############## REGION DE CATEGORIAS (NIVEL 1) ############## */}
                    <div id ="Drop-Familia" style={{background:'#f7ca91'}}>
                        <div className='designScroll Departamentos-lvl-1' >
                            {idCategoryFilter.length > 0 && idCategoryFilter.map(categoryL1 =>{
                                return(
                                    <div>
                                        <span 
                                            className='nav-link' 
                                            style={{fontSize:"0.9rem"}}
                                            // onClick={() => this.subCategorySearch(categoryL1.Code, "productos")}
                                            // onMouseOut = {() => this.renderSubCategories(categoryL1)}
                                            // onMouseOver = {() => this.renderSubCategories(categoryL1)}
                                        >{categoryL1.U_name}
                                        </span>
                                        {/* <div class="dropdown-divider"></div> */}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div  id='subMenuNivel2' className='designScroll Departamentos-lvl-2 '/*'wrapper'*/ style={{ background : 'white', }} >
                    </div>

                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        itemsReducer: store.ItemsReducer,
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        shoppingCartReducer: store.ShoppingCartReducer,
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
        setItemsSearch: value => dispatch({ type: DISPATCH_ID.ITEMS_SET_ITEMS, value }),
        setItemsFilterSearch: value => dispatch({ type: DISPATCH_ID.ITEMS_SAVE_ITEMS_FILTER, value }),

        setRole: value => dispatch({ type: DISPATCH_ID.SESSION_SET_ROLE, value }),
        addNotificationReference: value => dispatch({ type: DISPATCH_ID.NOTIFICATION_SET_ALERT_REFERENCE, value }),
        setBusiness: value => dispatch({ type: DISPATCH_ID.SESSION_SET_BUSINESS_ID, value }),
        setToken: value => dispatch({ type: DISPATCH_ID.SESSION_SET_TOKEN, value }),
        setUser: value => dispatch({ type: DISPATCH_ID.SESSION_SET_USER, value }),
        setRememberUser: value => dispatch({ type: DISPATCH_ID.SESSION_SET_REMEMBER_USER, value }),
        setLogOutReference: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_LOG_OUT_REFERENCE, value }),
        setIdCategory: value => dispatch({type: DISPATCH_ID.ITEMS_SET_IDCATEGORY, value}),
        setNextPage:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_NEXTPAGE, value}),
        setLocation:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_LOCATION, value}),
        setView:  value => dispatch({type: DISPATCH_ID.ITEMS_SET_VIEWCATEGORY, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MenuNavbar);